<template>
	<div>
		<el-container>
		  <el-aside width="auto" style=" background: #19191e;">
			  <CommentAside />
		  </el-aside>
		  <el-container>
			 <el-header>
				 <Commenthander></Commenthander>
			 </el-header>
			 <CommentTag></CommentTag>
		    <router-view></router-view>
		  </el-container>
		</el-container>
		
	</div>
	
</template>

<script>
	import CommentAside from "../components/commentAside.vue"
	import Commenthander from "../components/commentHander.vue"
	import CommentTag from "../components/commentTag.vue"
	export default{
		components:{
			CommentAside,
			Commenthander,
			CommentTag
		}
	}
</script>

<style lang="less" scopde>
	.el-header{
		padding: 0;
	}
	ul li{
		list-style :none;
	} 
	
</style>